import type { FlightOffer } from "@/lib/travelpayouts.server";

export type SelectedFlight = {
  offer: FlightOffer;
  passengers: number;
  savedAt: number;
};

const KEY = "mm.selectedFlight";

export function saveSelectedFlight(offer: FlightOffer, passengers = 1): void {
  if (typeof window === "undefined") return;
  try {
    const payload: SelectedFlight = { offer, passengers, savedAt: Date.now() };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private-mode errors
  }
}

export function readSelectedFlight(): SelectedFlight | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SelectedFlight;
  } catch {
    return null;
  }
}

export function clearSelectedFlight(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
